import React from 'react';
import styles from './tableLoader.module.css';

const TableLoader: React.FC = () => {
    return (
        <div className={styles.tableLoaderContainer}>
            <div className={styles.tableLoaderCircle}></div>
        </div>
    );
};

export default TableLoader;
